import { defineStore } from 'pinia'
import { ref } from 'vue'
import { TCoil } from '@/modules/receptions'

export const useCoilsStore = defineStore('Coils', () => {
  const selectedCoils = ref<TCoil[]>([])

  const setCoils = (payload: TCoil[]) => {
    selectedCoils.value = payload
  }

  return {
    selectedCoils,
    setCoils,
  }
})
